import { useState } from 'react'
import config from 'constants/config'

import SearchTrendingDestinations from '../SearchForm/SearchTrendingDestinations'
import GlobalSearchTabsPane from '../GlobalSearch/GlobalSearchTabsPane'
import GlobalSearchHeroContainer from '../GlobalSearch/GlobalSearchHeroContainer'
import useGlobalSearchVerticalTabs from 'hooks/GlobalSearch/useGlobalSearchVerticalTabs'
import TourV2TrendingDestinationsQuickFilters from '../TourV2/TourV2TrendingDestinationsQuickFilters'

import GlobalMobileSearchHeroBar from 'components/SearchV2/Components/Mobile/GlobalMobileSearchHeroBar'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

const StyledGlobalSearchHeroContainer = styled(GlobalSearchHeroContainer)`
  ${mediaQueryUp.tablet} {
    min-height: ${rem(450)};
  }
`

interface Props {
  title: string
  imageId?: string
}

function SearchHeader({
  title,
  imageId = config.searchFormSection.imageId,
}: Props) {
  const tabs = useGlobalSearchVerticalTabs()

  const [selectedTab, setSelectedTab] = useState<App.SearchVertical>([...tabs.keys()][0])

  return <StyledGlobalSearchHeroContainer
    heroImageId={imageId}
    title={title}
  >
    <GlobalSearchTabsPane
      tabs={tabs}
      selectedTab={selectedTab}
      onTabSelect={setSelectedTab}
    />

    {config.USE_INSPIRATIONAL_SEARCH && <GlobalMobileSearchHeroBar />}

    {selectedTab === 'hotels' && <SearchTrendingDestinations
      titleColour="neutral-eight"
      titleWeight="bold"
    />}
    {selectedTab === 'tours' &&
      <TourV2TrendingDestinationsQuickFilters titleColour="neutral-eight" titleWeight="bold" />}
  </StyledGlobalSearchHeroContainer>
}

export default SearchHeader
